import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, type LinkProps } from 'react-router-dom'

/**
 * <Link> whose absolute `to` is rewritten under the current language prefix:
 * <LangLink to="/products" /> renders /nl/products when the active language
 * is Dutch. Anything that is not an absolute string path is passed through.
 */
const LangLink = forwardRef<HTMLAnchorElement, LinkProps>(function LangLink(
  { to, ...rest },
  ref,
) {
  const { i18n } = useTranslation()
  const prefixed =
    typeof to === 'string' && to.startsWith('/')
      ? `/${i18n.language}${to === '/' ? '' : to}`
      : to
  return <Link ref={ref} to={prefixed} {...rest} />
})

export default LangLink
